import { render, staticRenderFns } from "./RiskExplorer.vue?vue&type=template&id=8c589ad8&scoped=true&"
import script from "./RiskExplorer.vue?vue&type=script&lang=js&"
export * from "./RiskExplorer.vue?vue&type=script&lang=js&"
import style0 from "./RiskExplorer.vue?vue&type=style&index=0&id=8c589ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c589ad8",
  null
  
)

export default component.exports